import { useEffect, useState } from 'react';

/**
 * Значение с задержкой: обновляется через `delay` мс после последнего изменения `value`.
 *
 * Для серверных фильтров по вводу (поиск по номеру накладной в «Складе»): запрос уходит не
 * на каждую клавишу, а когда пользователь перестал печатать — как поиск в «Клиентах».
 * Промежуточные значения (набрано «in», «inv») наружу не выходят.
 */
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
